import request from '@/utils/request.ts'

export const gettableinfo = (params: any) =>
  request({
    url: '/topicdata/getTopicData',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const addtopicdata = (params: any) =>
  request({
    url: '/topicdata/addTopicData',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const gettopicinfo = (params: any) =>
  request({
    url: '/topicdata/getGuideInfoById',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const gettopclist = (params: any) =>
  request({
    url: '/topic/getTopicInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const updateinfo = (params: any) =>
  request({
    url: '/topicdata/updateTopicInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const addtopic = (params: any) =>
  request({
    url: '/topic/addTopic',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const updatetopic = (params: any) =>
  request({
    url: '/topic/updateTopic',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 新增负责人
export const addmajor = (params: any) =>
  request({
    url: '/majortopic/saveOrUpdateMajorInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 获取负责人info
export const getmajorinfo = (params: any) =>
  request({
    url: '/majortopic/getMajorInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 新增课题论证
export const adddesign = (params: any) =>
  request({
    url: '/design/saveOrUpdateDesign',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 获取课题论证info
export const getdesigninfo = (params: any) =>
  request({
    url: '/design/getDesign',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 新增研究基础及条件
export const addbasics = (params: any) =>
  request({
    url: '/basics/saveOrupdateBasics',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 获取研究基础及条件info
export const getbasicsinfo = (params: any) =>
  request({
    url: '/basics/getCBasics',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 新增预期研究成果
export const addyqyjcg = (params: any) =>
  request({
    url: '/expectationresearch/saveOrUpdateExpectationresearch',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 获取新增预期研究成果info
export const getyqyjcginfo = (params: any) =>
  request({
    url: '/expectationresearch/getExpectationresearch',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 新增经费管理
export const addjfgl = (params: any) =>
  request({
    url: '/management/saveOrUpdateBudget',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 获取经费管理info
export const getjfglinfo = (params: any) =>
  request({
    url: '/management/getBudget',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 新增年度课题论证
export const addndktlz = (params: any) =>
  request({
    url: '/activity/saveOrUpdateActivity',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 获取年度课题论证info
export const getndktlzinfo = (params: any) =>
  request({
    url: '/activity/getActivity',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 新增经费预算
export const addbudget = (params: any) =>
  request({
    url: '/budget/saveOrUpdateBudget',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 获取年度课题论证info
export const getbudgetinfo = (params: any) =>
  request({
    url: '/budget/getBudget',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 新增单位意见
export const addopinion = (params: any) =>
  request({
    url: '/opinion/saveOrUpdateOpinion',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 获取单位意见info
export const getopinioninfo = (params: any) =>
  request({
    url: '/opinion/getOpinion',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 上传相关证书接口
export const uploadzsxg = (params: any) =>
  request({
    url: '/cooperative/uploadFile',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 更新相关证书内容

export const updateuploadfile = (params: any) =>
  request({
    url: '/cooperative/updatePic',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 删除文pic
export const removefile = (params: any) =>
  request({
    url: '/cooperative/removePic',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// // 获取相关证书info
export const getcertificateinfo = (params: any) =>
  request({
    url: '/cooperative/getPicList',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 下载
//andy  2022-06-20 下载任务书
export const downloadfile = (params: any) =>
  request({
    url: '/accessory/downloadDoc',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
//andy  2022-06-20 下载申请书
export const downloadfileapplication = (params: any) =>
  request({
    url: '/accessoryNew/downloadDoc',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 下载
export const downloadjffile = (params: any) =>
  request({
    url: '/guidedetail/downloadDoc',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

// 下载已填写的申报内容
export const downloadPDF = () =>
  request({
    url: '/topicdatadetail/exp/outWord/1',
    // method: 'post',
    // data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 查已上传的课题附件列表
export const getktsjinfo = (params: any) =>
  request({
    url: '/cooperative/getAccessoryList',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 删除上传的课题附件列表
export const updatetopicfile = (params: any) =>
  request({
    url: '/cooperative/updateFile',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 获取课题方向集合
export const getguidlist = (params: any) =>
  request({
    url: '/guide/getGuideInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 获取指南集合
export const gettpoicinfo = (params: any) =>
  request({
    url: '/topic/getTopicInfoById',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// 获取生成得申报pdf集合
export const downloadpdf = (params: any) =>
  request({
    url: '/pdfstate/getPdf',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
